<script>
export default {
    name: "mediapoolListHeaderRow",
    computed: {
        translations() {
            return {
                added: Lang.langGet("Added"),
                modified: Lang.langGet("Modified"),
                name: Lang.langGet("Name"),
                size: Lang.langGet("Size"),
                tags: Lang.langChoice("Tag|Tags", 2),
                validity: Lang.langGet("Validity"),
            }
        },
    },
}
</script>

<template>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-3">
            <strong>{{ translations.name }}</strong>
        </div>
        <div class="col-md-1">
            <strong>{{ translations.tags }}</strong>
        </div>
        <div class="col-md-2 text-center">
            <strong>{{ translations.validity }}</strong>
        </div>
        <div class="col-md-1 text-right">
            <strong>{{ translations.size }}</strong>
        </div>
        <div class="col-md-1">
            <strong>{{ translations.added }}</strong>
        </div>
        <div class="col-md-1">
            <strong>{{ translations.modified }}</strong>
        </div>
        <div class="col-md-1"></div>
    </div>
</template>
